export default __webpack_public_path__ + "locales/ar-SA/About.json?hash=97e449076b309ef9a1d3db2a1d129620";